import styled from "styled-components";
import { Colors } from "../../config/Constants";
import Modal from "../Modal";
import Selectfield from "../Merchant/Selectfield";
import DatePickerInput from "../Datepicker";
import Textarea from "../Textarea";
import Button from "../Button";

interface Props {
  today: Date;
  onBlockSlotClose: any;
  onBlockSlot: any;
  timeSlot: any;
  products: any;
  data: any;
  onSlotDataChange: any;
}

const BlockSlotModal = ({
  today,
  onBlockSlotClose,
  onBlockSlot,
  timeSlot,
  products,
  data,
  onSlotDataChange,
}: Props) => {
  return (
    <Modal setOpenOrClose={onBlockSlotClose} variant={"none"} width="21.2rem">
      <div style={{ padding: "1.5rem 1rem", flexDirection: "column" }}>
        <BlockDateHeader>
          <HeaderTitle>Blocked Slot</HeaderTitle>
          <Close
            src={require("../../assets/images/ei_close.png")}
            alt="close"
            onClick={onBlockSlotClose}
          />
        </BlockDateHeader>
        <BlockDateBody>
          <SelectWrapper>
            <Selectfield
              data={products}
              name="product"
              label="Select Product"
              required
              value={data?.product}
              onChange={(e) => onSlotDataChange(e)}
            />
            <Selectfield
              data={timeSlot}
              name="slot"
              label="Select Time Slot"
              required
              value={data?.slot}
              onChange={(e) => onSlotDataChange(e)}
            />
          </SelectWrapper>
          <DateContainer>
            <Label>From Date</Label>
            <DatePickerInput
              //@ts-ignore
              outlined={true}
              value={data?.fromDate}
              width="15.75rem"
              minDate={today}
              onChange={(e) =>
                onSlotDataChange({ target: { value: e, name: "fromDate" } })
              }
              // setFromDate(e);
              // setToDate(null);
              // }}
            />
          </DateContainer>
          <Textarea
            name="comment"
            placeholder="Comments"
            onChange={(e) => onSlotDataChange(e)}
            value={data?.comment}
            required
            label="Comments"
          />
          <ButtonWrapper>
            <Button
              label="Submit"
              variant="filled"
              width="100%"
              color={Colors.red}
              onClick={onBlockSlot}
            />
          </ButtonWrapper>
        </BlockDateBody>
      </div>
    </Modal>
  );
};

const ButtonWrapper = styled.label`
  margin-top: 1rem;
`;

const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 1rem;
`;

const DateContainer = styled.div`
  margin: 1rem 0;
`;
const Label = styled.label`
  font-family: "Poppins-Medium";
  font-size: 0.8rem;
  color: ${Colors.comet};
  margin-top: 1.5rem;
`;

const BlockDateBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1.25rem;
  //   gap:0.5rem;
`;

const BlockDateHeader = styled.div`
  display: flex;
  justify-content: center;
`;
const HeaderTitle = styled.div`
  font-family: "Poppins-Medium";
  font-size: 1rem;
  color: ${Colors.mineShaft};
`;
const Close = styled.img`
  transform: translate(4.375rem, -0.25rem);
  cursor: pointer;
`;
export default BlockSlotModal;
